import { theme } from '@nicejob-library/design-system';
import {
    AtomResetPasswordForm,
    AuthCard,
    AuthContainer,
    AuthContent,
    AuthError,
    AuthFooter,
    AuthLoading,
} from '@nicejob-library/design-system/authentication';
import { translate } from '@nicejob-library/internationalization';
import React, { ReactElement, useState } from 'react';
import { ThemeProvider } from 'styled-components';
import { IAtomResetPasswordPageProps } from '../../../../types/login.types';
import { HeaderLogo } from '../../components/common/HeaderLogo';
import { LoginLink } from '../../components/common/LoginLink';

export function AtomResetPasswordPage(props: IAtomResetPasswordPageProps): ReactElement {
    /**
     * NB: Cannot use hooks in top-level page component
     */
    return (
        <ThemeProvider theme={theme}>
            <AtomResetPasswordPageContent {...props} />
        </ThemeProvider>
    );
}

function AtomResetPasswordPageContent(props: IAtomResetPasswordPageProps): ReactElement {
    const { branding, email, code, is_multiple_platforms, error_message, language } = props;

    const [is_loading, setIsLoading] = useState(false);

    /**
     * Set loading state when submitting the form
     */
    function onReset(): void {
        setIsLoading(true);
    }

    return (
        <AuthContainer>
            <HeaderLogo branding={branding} />

            {is_loading && <AuthLoading />}

            <AuthContent is_loading={is_loading}>
                <AuthCard>
                    <AtomResetPasswordForm
                        code={code}
                        email={email || ''}
                        is_multiple_platforms={is_multiple_platforms}
                        post_url={`/u/reset_password?code=${code}`}
                        onSubmit={onReset}
                        language={language}
                    />

                    <AuthError
                        error={error_message}
                        error_prefix={translate({
                            namespace: 'common',
                            key: 'text.error',
                            language,
                        })}
                    />
                </AuthCard>

                <AuthFooter>
                    <LoginLink branding={branding} language={language} />
                </AuthFooter>
            </AuthContent>
        </AuthContainer>
    );
}
